import React, { useEffect } from 'react';
import { BlackoutLanding } from './pages/BlackoutLanding';
import { initPixel } from './lib/pixel';
const SITE_TITLE = 'BLACKOUT UNIT™ — BU-01 // Ultimate Mask';
const SITE_DESCRIPTION = 'This isn’t a costume. It’s a transformation. The premium skull mask built to dominate Halloween.';
const SITE_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/68b5ecfc-31d6-400f-9c4d-6c24fced1d72.jpg';

// Keep the document title + social/preview meta tags clean. Social crawlers
// read static HTML at crawl time, so the definitive link preview is set in
// the PUBLISH settings.
function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
interface AppProps {
  /** Turn off if bonus color crystal sets are not actually shipped with bundles. */
  showCrystalBonus?: boolean;
}
export function App({
  showCrystalBonus = true
}: AppProps) {
  useEffect(() => {
    initPixel();
    document.title = SITE_TITLE;
    setMeta('name', 'description', SITE_DESCRIPTION);
    setMeta('property', 'og:title', SITE_TITLE);
    setMeta('property', 'og:description', SITE_DESCRIPTION);
    setMeta('property', 'og:image', SITE_IMAGE);
    setMeta('property', 'og:type', 'website');
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', SITE_TITLE);
    setMeta('name', 'twitter:description', SITE_DESCRIPTION);
    setMeta('name', 'twitter:image', SITE_IMAGE);
  }, []);
  return <BlackoutLanding showCrystalBonus={showCrystalBonus} data-id="element-0" data-mp="3dkl60fx4dbm2" />;
}